export default __webpack_public_path__ + "af285a9e7748ce72b5a00e225fe3c162.svg";